// Responsive boundaries shared across admin-web (BL-1438).
//
// These live in `constants/` rather than on the component that first needed
// them so a second consumer never has to import a table to learn where "phone"
// starts — which is how `PHONE_CARD_BREAKPOINT` came to exist as a page-local
// const on `auctions/page.tsx` plus ten literals across two test files.

/**
 * Below this CONTAINER width, a table declaring the card projection renders
 * stacked cards instead of a `<table>` (see `DataTableV2`'s card-projection
 * contract).
 *
 * Measured against the table's own container, not the viewport, so a table
 * inside a narrow panel collapses on its own terms.
 *
 * 768 matches the clerk console's phone tier (`@container (max-width: 767px)`
 * in `settings-v2.css`), so a clerk moving between the console and a list
 * crosses one boundary, not two.
 */
export const PHONE_CARD_BREAKPOINT = 768;
